"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_POSITION = exports.UPDATE_MARGIN_BALANCES = exports.SET_MARGIN_LEVERAGE = exports.REQUEST_OPEN_POSITIONS = exports.REQUEST_MARGIN_POSITIONS_PAYMENTS = exports.REQUEST_MARGIN_LEVERAGES = exports.REQUEST_MARGIN_INSTRUMENTS = exports.REQUEST_MARGIN_BALANCES = exports.REQUEST_MARGIN_ACCOUNT_EQUITY = exports.REQUEST_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS = exports.REQUEST_CLOSED_POSITIONS = exports.REMOVE_MARGIN_NOTIFICATION_ICON = exports.RECEIVE_SYSTEM_MARGIN_ENABLED = exports.RECEIVE_REPAYMENT_ASSET_OPTIONS = exports.RECEIVE_OPEN_POSITIONS = exports.RECEIVE_MAX_TRANSFER_AMOUNT = exports.RECEIVE_MARGIN_PRODUCT_CONFIGS = exports.RECEIVE_MARGIN_KVP_INFO = exports.RECEIVE_MARGIN_INSTRUMENTS = exports.RECEIVE_MARGIN_BALANCES = exports.RECEIVE_MARGIN_ACCOUNT_INFO = exports.RECEIVE_MARGIN_ACCOUNT_EQUITY = exports.RECEIVE_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS = exports.RECEIVE_CLOSED_POSITIONS = exports.MARGIN_EQUITY_ERROR = exports.DISMISS_MARGIN_NOTIFICATION = exports.ADD_MARGIN_NOTIFICATION_ICON = void 0;
/**
 * Margin Trading Action Type Constants
 *
 * This file contains all action type constants used by margin reducers and actions.
 * Centralizing these constants here prevents circular dependencies between
 * reducers and action files.
 */

// Margin Account Info
var RECEIVE_MARGIN_ACCOUNT_INFO = exports.RECEIVE_MARGIN_ACCOUNT_INFO = 'RECEIVE_MARGIN_ACCOUNT_INFO';

// Margin Account Equity
var RECEIVE_MARGIN_ACCOUNT_EQUITY = exports.RECEIVE_MARGIN_ACCOUNT_EQUITY = 'RECEIVE_MARGIN_ACCOUNT_EQUITY';
var REQUEST_MARGIN_ACCOUNT_EQUITY = exports.REQUEST_MARGIN_ACCOUNT_EQUITY = 'REQUEST_MARGIN_ACCOUNT_EQUITY';
var MARGIN_EQUITY_ERROR = exports.MARGIN_EQUITY_ERROR = 'MARGIN_EQUITY_ERROR';

// Margin Leverages
var REQUEST_MARGIN_LEVERAGES = exports.REQUEST_MARGIN_LEVERAGES = 'REQUEST_MARGIN_LEVERAGES';
var SET_MARGIN_LEVERAGE = exports.SET_MARGIN_LEVERAGE = 'SET_MARGIN_LEVERAGE';

// Margin Instruments
var REQUEST_MARGIN_INSTRUMENTS = exports.REQUEST_MARGIN_INSTRUMENTS = 'REQUEST_MARGIN_INSTRUMENTS';
var RECEIVE_MARGIN_INSTRUMENTS = exports.RECEIVE_MARGIN_INSTRUMENTS = 'RECEIVE_MARGIN_INSTRUMENTS';

// Margin Balances
var REQUEST_MARGIN_BALANCES = exports.REQUEST_MARGIN_BALANCES = 'REQUEST_MARGIN_BALANCES';
var RECEIVE_MARGIN_BALANCES = exports.RECEIVE_MARGIN_BALANCES = 'RECEIVE_MARGIN_BALANCES';
var UPDATE_MARGIN_BALANCES = exports.UPDATE_MARGIN_BALANCES = 'UPDATE_MARGIN_BALANCES';

// Margin Positions (History)
var REQUEST_OPEN_POSITIONS = exports.REQUEST_OPEN_POSITIONS = 'REQUEST_OPEN_POSITIONS';
var REQUEST_CLOSED_POSITIONS = exports.REQUEST_CLOSED_POSITIONS = 'REQUEST_CLOSED_POSITIONS';
var REQUEST_MARGIN_POSITIONS_PAYMENTS = exports.REQUEST_MARGIN_POSITIONS_PAYMENTS = 'REQUEST_MARGIN_POSITIONS_PAYMENTS';
var RECEIVE_OPEN_POSITIONS = exports.RECEIVE_OPEN_POSITIONS = 'RECEIVE_OPEN_POSITIONS';
var RECEIVE_CLOSED_POSITIONS = exports.RECEIVE_CLOSED_POSITIONS = 'RECEIVE_CLOSED_POSITIONS';
var UPDATE_POSITION = exports.UPDATE_POSITION = 'UPDATE_POSITION';
var RECEIVE_REPAYMENT_ASSET_OPTIONS = exports.RECEIVE_REPAYMENT_ASSET_OPTIONS = 'RECEIVE_REPAYMENT_ASSET_OPTIONS';

// Margin KVP Info
var RECEIVE_MARGIN_KVP_INFO = exports.RECEIVE_MARGIN_KVP_INFO = 'RECEIVE_MARGIN_KVP_INFO';

// System Margin Enabled
var RECEIVE_SYSTEM_MARGIN_ENABLED = exports.RECEIVE_SYSTEM_MARGIN_ENABLED = 'RECEIVE_SYSTEM_MARGIN_ENABLED';

// Margin Product Configs
var RECEIVE_MARGIN_PRODUCT_CONFIGS = exports.RECEIVE_MARGIN_PRODUCT_CONFIGS = 'RECEIVE_MARGIN_PRODUCT_CONFIGS';

// Max Transfer Amount
var RECEIVE_MAX_TRANSFER_AMOUNT = exports.RECEIVE_MAX_TRANSFER_AMOUNT = 'RECEIVE_MAX_TRANSFER_AMOUNT';

// Margin Notifications
var DISMISS_MARGIN_NOTIFICATION = exports.DISMISS_MARGIN_NOTIFICATION = 'DISMISS_MARGIN_NOTIFICATION';
var ADD_MARGIN_NOTIFICATION_ICON = exports.ADD_MARGIN_NOTIFICATION_ICON = 'ADD_MARGIN_NOTIFICATION_ICON';
var REMOVE_MARGIN_NOTIFICATION_ICON = exports.REMOVE_MARGIN_NOTIFICATION_ICON = 'REMOVE_MARGIN_NOTIFICATION_ICON';

// Instrument Verification Level Configs
var REQUEST_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS = exports.REQUEST_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS = 'REQUEST_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS';
var RECEIVE_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS = exports.RECEIVE_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS = 'RECEIVE_INSTRUMENT_VERIFICATION_LEVEL_CONFIGS';